import { render, staticRenderFns } from "./_safe.vue?vue&type=template&id=4e86f25f&scoped=true"
import script from "./_safe.vue?vue&type=script&lang=js"
export * from "./_safe.vue?vue&type=script&lang=js"
import style0 from "./_safe.vue?vue&type=style&index=0&id=4e86f25f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e86f25f",
  null
  
)

export default component.exports